import React from 'react';
import {Link} from 'react-router-dom';

import menuItem from './menu_item';

type Props = {
    to: string;
    content: React.ReactNode;
    onClick?: () => void;
    'data-testid'?: string;
}

export const MenuItemLinkImpl: React.FC<Props> = ({to, content, onClick, 'data-testid': dataTestId}: Props) => (
    <Link data-testid={dataTestId} to={to} onClick={onClick}>{content}</Link>
);

const MenuItemLink = menuItem(MenuItemLinkImpl);
MenuItemLink.displayName = 'MenuItemLink';

export default MenuItemLink;
